import { render } from "./exercise.vue?vue&type=template&id=89d30ea8&scoped=true"
import script from "./exercise.vue?vue&type=script&lang=ts"
export * from "./exercise.vue?vue&type=script&lang=ts"

import "./exercise.vue?vue&type=style&index=0&id=89d30ea8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89d30ea8"

export default script